import React from "react";
import { Row, Label, FormGroup, Button, Table } from "reactstrap";
import DatePicker from "react-datepicker";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { getKTMNRevenue, getKTMTRevenue, getTransRevenue } from "../api/thirdPartyApi";
import { convertDate } from "../../../utils/";
import Notification from "./../../../components/Notification";
const moment = require("moment");

const THIRD_PARTY_ID = 5;

const money = (value) => Number(value || 0).getMoneyFormat();

const amountAt = (row, index) => {
    const source = row.source || {};
    const moneyArray = source.moneyArray || [];
    return Number(moneyArray[index] || 0);
};

const kenoAmount = (row) => amountAt(row, 6) - Number((row.source && row.source.kenoBaoMoney) || 0);

const kenoBaoAmount = (row) => Number((row.source && row.source.kenoBaoMoney) || 0);

class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fromdate: null,
            todate: null,
            isLoading: false,
            revKTMN: {},
            revKTMT: {},
            revThirdParty: [],
        };
        this.headerKTMN = [
            { label: "Ngày" },
            { label: "Tiền vé" },
            { label: "Phí dịch vụ" },
            { label: "Tổng" },
        ];
        this.tableheaderThirdParty = [
            { label: "Mã POS" },
            { label: "Ngày" },
            { label: "LOTO535" },
            { label: "3D" },
            { label: "3D+" },
            { label: "Max 3d Pro" },
            { label: "Mega 6/45" },
            { label: "Power 6/55" },
            { label: "keno" },
            { label: "Keno Bao" },
            { label: "Kiến thiết" },
            { label: "Điện toán 235" },
            { label: "Điện toán 234" },
            { label: "Điện toán 6x36" },
            { label: "Thần tài" },
            { label: "Điện toán 123" },
            { label: "Phí dịch vụ" },
            { label: "Doanh thu - dịch vụ" },
            { label: "Tổng tiền bán vé" },
        ];
        this.filter = {
            thirdPartyId: THIRD_PARTY_ID,
        };
    }

    formatDate(value) {
        if (!value) return "";
        const parsed = moment(value);
        return parsed.isValid() ? parsed.format("DD-MM-YYYY") : String(value).substr(0, 10);
    }

    groupByName(rows) {
        return rows.reduce((acc, obj) => {
            const key = obj.thirdPartyName || "";
            if (!acc[key]) acc[key] = [];
            acc[key].push(obj);
            return acc;
        }, {});
    }

    getRevenue() {
        if (this.state.isLoading) return;
        this.setState({ isLoading: true });
        Object.assign(this.filter, {
            fromdate: convertDate(this.state.fromdate),
            todate: convertDate(this.state.todate),
            thirdPartyId: THIRD_PARTY_ID,
        });
        let pending = 3;
        const done = () => {
            pending -= 1;
            if (pending <= 0) this.setState({ isLoading: false });
        };
        const notifyError = () => {
            Notification("error", "Có lỗi xảy ra ", "Kiểm tra lại các trường đầu vào hoặc báo cho quản trị viên");
        };

        const onlyParty = (rows) => (rows || []).filter((row) => Number(row.thirdPartyId) === THIRD_PARTY_ID);

        getKTMNRevenue(this.filter, (err, result) => {
            if (err) {
                notifyError();
            } else {
                const rows = onlyParty(result).map((e) => ({
                    ...e,
                    createdDate: this.formatDate(e.createdDate),
                }));
                this.setState({ revKTMN: this.groupByName(rows) });
            }
            done();
        });
        getKTMTRevenue(this.filter, (err, result) => {
            if (err) {
                notifyError();
            } else {
                const rows = onlyParty(result).map((e) => ({
                    ...e,
                    createdDate: this.formatDate(e.createdDate),
                }));
                this.setState({ revKTMT: this.groupByName(rows) });
            }
            done();
        });
        getTransRevenue(this.filter, (err, result) => {
            if (err) {
                notifyError();
            } else {
                this.setState({ revThirdParty: onlyParty(result) });
            }
            done();
        });
    }

    renderProductTable(groups, tableId) {
        const dataReturn = [];
        for (let key in groups) {
            if (!Object.prototype.hasOwnProperty.call(groups, key)) continue;
            const row = groups[key];
            const ticketTotal = row.reduce((sum, item) => sum + Number(item.revenueTicket || 0), 0) * 1000;
            const serviceTotal = row.reduce((sum, item) => sum + Number(item.revenueService || 0), 0) * 1000;
            dataReturn.push(
                <div key={key} style={{ margin: 10 }}>
                    <Table className="table-bordered table-header-center" id={tableId}>
                        <thead>
                            <tr>
                                <td colSpan={4}>{key}</td>
                            </tr>
                            <tr>
                                {this.headerKTMN.map((header) => (
                                    <th key={header.label}>{header.label}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr style={{ fontWeight: "bold" }}>
                                <td>Tổng</td>
                                <td>{money(ticketTotal)}</td>
                                <td>{money(serviceTotal)}</td>
                                <td>{money(ticketTotal + serviceTotal)}</td>
                            </tr>
                            {row.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.createdDate}</td>
                                    <td>{money(Number(item.revenueTicket || 0) * 1000)}</td>
                                    <td>{money(Number(item.revenueService || 0) * 1000)}</td>
                                    <td>{money((Number(item.revenueTicket || 0) + Number(item.revenueService || 0)) * 1000)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            );
        }
        return dataReturn;
    }

    sumPrint(data, pick) {
        return data.reduce((sum, row) => sum + pick(row), 0) * 1000;
    }

    renderThirdPartyRevenue() {
        const names = [];
        for (let data of this.state.revThirdParty) {
            if (names.indexOf(data.thirdPartyName) === -1) names.push(data.thirdPartyName);
        }
        return names.map((store) => {
            const data = this.state.revThirdParty.filter((e) => e.thirdPartyName === store);
            return (
                <Row key={store} className="pt-2 p-1 scroll-table">
                    <Table className="table-bordered table-header-center" id="revenue-print">
                        <thead>
                            <tr>
                                <td colSpan={19}>{store}</td>
                            </tr>
                            <tr>
                                {this.tableheaderThirdParty.map((header) => (
                                    <th key={header.label}>{header.label}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr style={{ fontWeight: "bold" }}>
                                <td>Tổng</td>
                                <td></td>
                                <td>{money(this.sumPrint(data, (row) => amountAt(row, 15)))}</td>
                                <td>{money(this.sumPrint(data, (row) => amountAt(row, 4)))}</td>
                                <td>{money(this.sumPrint(data, (row) => amountAt(row, 5)))}</td>
                                <td>{money(this.sumPrint(data, (row) => amountAt(row, 13)))}</td>
                                <td>{money(this.sumPrint(data, (row) => amountAt(row, 1)))}</td>
                                <td>{money(this.sumPrint(data, (row) => amountAt(row, 2)))}</td>
                                <td>{money(this.sumPrint(data, kenoAmount))}</td>
                                <td>{money(this.sumPrint(data, kenoBaoAmount))}</td>
                                <td>{money(this.sumPrint(data, (row) => amountAt(row, 14)))}</td>
                                <td>{money(this.sumPrint(data, (row) => amountAt(row, 7)))}</td>
                                <td>{money(this.sumPrint(data, (row) => amountAt(row, 8)))}</td>
                                <td>{money(this.sumPrint(data, (row) => amountAt(row, 9)))}</td>
                                <td>{money(this.sumPrint(data, (row) => amountAt(row, 10)))}</td>
                                <td>{money(this.sumPrint(data, (row) => amountAt(row, 11)))}</td>
                                <td>{money(this.sumPrint(data, (row) => amountAt(row, 12)))}</td>
                                <td>{money(this.sumPrint(data, (row) => amountAt(row, 0) - amountAt(row, 12)))}</td>
                                <td>{money(this.sumPrint(data, (row) => amountAt(row, 0)))}</td>
                            </tr>
                            {data.map((row, index) => (
                                <tr key={index}>
                                    <td>{row.walletId}</td>
                                    <td>{this.formatDate(row.createdDate)}</td>
                                    <td>{money(amountAt(row, 15) * 1000)}</td>
                                    <td>{money(amountAt(row, 4) * 1000)}</td>
                                    <td>{money(amountAt(row, 5) * 1000)}</td>
                                    <td>{money(amountAt(row, 13) * 1000)}</td>
                                    <td>{money(amountAt(row, 1) * 1000)}</td>
                                    <td>{money(amountAt(row, 2) * 1000)}</td>
                                    <td>{money(kenoAmount(row) * 1000)}</td>
                                    <td>{money(kenoBaoAmount(row) * 1000)}</td>
                                    <td>{money(amountAt(row, 14) * 1000)}</td>
                                    <td>{money(amountAt(row, 7) * 1000)}</td>
                                    <td>{money(amountAt(row, 8) * 1000)}</td>
                                    <td>{money(amountAt(row, 9) * 1000)}</td>
                                    <td>{money(amountAt(row, 10) * 1000)}</td>
                                    <td>{money(amountAt(row, 11) * 1000)}</td>
                                    <td>{money(amountAt(row, 12) * 1000)}</td>
                                    <td>{money((amountAt(row, 0) - amountAt(row, 12)) * 1000)}</td>
                                    <td>{money(amountAt(row, 0) * 1000)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Row>
            );
        });
    }

    renderSection(title, tableId, content) {
        return (
            <div>
                <div className="mx-4 p-3 w-120 borderRadius text-center">
                    <div className="d-inline">
                        <span className="content-title-bold">{title}</span>
                    </div>
                    <ReactHTMLTableToExcel
                        id={`${tableId}-xls-button`}
                        className="download-table-xls-button float-right d-inline"
                        table={tableId}
                        filename={`${title} TỪ ${this.filter.fromdate || ""} ĐẾN ${this.filter.todate || ""}`}
                        sheet="sheet1"
                        buttonText="Tải xuống"
                    />
                </div>
                <Row style={{ justifyContent: "center" }}>{content}</Row>
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                <Row className="justify-content-center m-0">
                    <FormGroup className="mb-3 revenueStatistic_main_formGroup">
                        <Label className="d-block">Ngày bắt đầu</Label>
                        <DatePicker
                            isClearable
                            showPopperArrow={false}
                            selected={this.state.fromdate === null ? new Date() : this.state.fromdate}
                            onChange={(date) => this.setState({ fromdate: date })}
                            dateFormat="dd-MM-yyyy"
                        />
                    </FormGroup>
                    <FormGroup className="mb-3 ml-3 revenueStatistic_main_formGroup">
                        <Label className="d-block">Ngày kết thúc</Label>
                        <DatePicker
                            isClearable
                            showPopperArrow={false}
                            selected={this.state.todate === null ? new Date() : this.state.todate}
                            onChange={(date) => this.setState({ todate: date })}
                            dateFormat="dd-MM-yyyy"
                        />
                    </FormGroup>
                    <div className="mt-4 p-2">
                        <Button color="primary" onClick={this.getRevenue.bind(this)}>
                            Tìm kiếm
                        </Button>
                    </div>
                </Row>
                <div className="mx-4 p-3 mt-2 w-120 text-center">
                    {this.renderSection("DOANH THU KTMN", "revenue-ktmn", this.renderProductTable(this.state.revKTMN, "revenue-ktmn"))}
                    {this.renderSection("DOANH THU IN VÉ", "revenue-print", this.renderThirdPartyRevenue())}
                    {this.renderSection("DOANH THU KTMT", "revenue-ktmt", this.renderProductTable(this.state.revKTMT, "revenue-ktmt"))}
                </div>
            </React.Fragment>
        );
    }
}

export default Main;
